import { Injectable, NgModule, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DateAdapter, NativeDateAdapter, provideNativeDateAdapter } from "@angular/material/core";
import { LuxonDateAdapter, provideLuxonDateAdapter } from "@angular/material-luxon-adapter";
import { TranslocoLocaleService } from "@ngneat/transloco-locale";

/**
 * Date adapters that follow the active Transloco locale, so datepicker
 * day/month names change together with the selected language.
 */
@Injectable()
export class LocalizedNativeDateAdapter extends NativeDateAdapter {
  constructor() {
    super();
    inject(TranslocoLocaleService).localeChanges$
      .pipe(takeUntilDestroyed())
      .subscribe(locale => this.setLocale(locale));
  }
}

@Injectable()
export class LocalizedLuxonDateAdapter extends LuxonDateAdapter {
  constructor() {
    super();
    inject(TranslocoLocaleService).localeChanges$
      .pipe(takeUntilDestroyed())
      .subscribe(locale => this.setLocale(locale));
  }
}

/** Drop-in replacement for MatNativeDateModule. */
@NgModule({
  providers: [
    provideNativeDateAdapter(),
    { provide: DateAdapter, useClass: LocalizedNativeDateAdapter },
  ],
})
export class LocalizedNativeDateModule {}

/** Drop-in replacement for MatLuxonDateModule. */
@NgModule({
  providers: [
    provideLuxonDateAdapter(),
    { provide: DateAdapter, useClass: LocalizedLuxonDateAdapter },
  ],
})
export class LocalizedLuxonDateModule {}
